/* Gingerlilly: hover a colour swatch on a product card to preview that colour's image.
   Markup comes from snippets/gl-card-swatches.liquid; the preview container
   (.gl-card-preview) is rendered by snippets/product-block.liquid. Desktop only. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var preloadedRows = new WeakSet();

  function previewImage(block) {
    var container = block.querySelector('.gl-card-preview');
    if (!container) return null;
    var img = container.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.decoding = 'async';
      img.alt = '';
      container.appendChild(img);
    }
    return img;
  }

  function showSwatch(swatch) {
    var block = swatch.closest('.product-block');
    if (!block) return;
    var src = swatch.dataset.glSrc;
    if (!src) {
      // Current colour (or no image): fall back to the card's own images.
      block.classList.remove('gl-previewing');
      return;
    }
    var img = previewImage(block);
    if (!img) return;
    if (img.dataset.glSrc !== src) {
      var row = swatch.closest('.gl-card-swatches');
      img.sizes = (row && row.dataset.glSizes) || '50vw';
      img.srcset = swatch.dataset.glSrcset || '';
      img.src = src;
      img.alt = swatch.dataset.glAlt || '';
      img.dataset.glSrc = src;
    }
    block.classList.add('gl-previewing');
  }

  function preloadRow(row) {
    if (preloadedRows.has(row)) return;
    preloadedRows.add(row);
    var sizes = row.dataset.glSizes || '50vw';
    row.querySelectorAll('.gl-card-swatch[data-gl-src]').forEach(function (swatch) {
      var img = new Image();
      img.sizes = sizes;
      img.srcset = swatch.dataset.glSrcset || '';
      img.src = swatch.dataset.glSrc;
    });
  }

  document.addEventListener('mouseover', function (evt) {
    var row = evt.target.closest && evt.target.closest('.gl-card-swatches');
    if (!row) return;
    preloadRow(row);
    var swatch = evt.target.closest('.gl-card-swatch');
    if (swatch) showSwatch(swatch);
  });

  document.addEventListener('mouseout', function (evt) {
    var row = evt.target.closest && evt.target.closest('.gl-card-swatches');
    if (!row) return;
    if (evt.relatedTarget && row.contains(evt.relatedTarget)) return;
    var block = row.closest('.product-block');
    if (block) block.classList.remove('gl-previewing');
  });
})();
